import React from 'react';
import { Loading, PageNotFound } from '@components/common';
import { useCreateTempAlertDashboard } from './hooks/useCreateTempAlertDashboard';
import { useParams } from 'react-router-dom';

export const PreAiAlertDiagnostics = (props) => {
  const params: any = useParams();
  const alertId = params.aiAlertId;
  const alertType = 'VIDEO_ALERT';

  const { isFetching } = useCreateTempAlertDashboard({ alertType, alertId });

  if (isFetching) {
    return <Loading />;
  } else if (!alertId) {
    return <PageNotFound />;
  }

  return null;
};
